import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PrerenderReady from './PrerenderReady';
import { FileQuestion } from 'lucide-react';

// Wczesniej apka nie mialo zadnej trasy catch-all - nieznaleziony URL renderowal calkowicie pusta
// strone (React Router v6 bez path="*" po prostu nic nie renderuje). react-snap zawsze probuje
// crawlowac /404.html (wbudowana konwencja narzedzia) - bez realnej tresci ta pusta strona trafiala
// do wygenerowanego dist/404.html. Prawdziwa strona 404 tu naprawia oba problemy naraz.
// 09.08, audyt przed wdrozeniem: uzywal <PublicNavBar> (marka "ISOForge" + linki do HLS
// Builder/Power Modules/Cennik/partner - strony wyciete z tego builda, patrz App.jsx) - jedyne
// miejsce gdzie odwiedzajacy trafiajacy na zepsuty/nieistniejacy link widzialby cudza marke i
// martwa nawigacje. Zastapione prostym, samodzielnym naglowkiem bez zaleznosci od ISO Forge.
export default function NotFoundPage() {
  const navigate = useNavigate();
  const [lang] = useState(() => localStorage.getItem('iso_lang') || 'pl');
  const e = lang === 'en';

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-page)', color: 'var(--text-primary)', fontFamily: "'Inter','Inter Fallback','Segoe UI',sans-serif" }}>
      <Helmet>
        <title>{e ? '404 - Page not found | Gap Assessment by MQS' : '404 - Strona nie znaleziona | Gap Assessment by MQS'}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <main style={{ maxWidth: 640, margin: '0 auto', padding: '100px 24px', textAlign: 'center' }}>
        <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'center' }}>
          <FileQuestion size={56} color="var(--text-tertiary)" strokeWidth={1.5} />
        </div>
        <h1 style={{ fontSize: 'clamp(1.6rem, 4vw, 2.2rem)', fontWeight: 800, marginBottom: 12 }}>
          {e ? 'Page not found' : 'Strona nie została znaleziona'}
        </h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', marginBottom: 32 }}>
          {e
            ? 'The page you are looking for does not exist or has been moved.'
            : 'Strona, której szukasz, nie istnieje lub została przeniesiona.'}
        </p>
        <a href="/" onClick={ev => { ev.preventDefault(); navigate('/'); }} style={{
          background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 10,
          padding: '12px 28px', fontSize: '0.9rem', fontWeight: 700, cursor: 'pointer',
          textDecoration: 'none', display: 'inline-block',
        }}>
          {e ? 'Back to homepage' : 'Wróć na stronę główną'}
        </a>
      </main>
      <PrerenderReady />
    </div>
  );
}
